export const defaultAiAssistantInfo = {
	title: "Ai Learning Assistant",
	alias: "AiLA",
	icon: "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
	showOriginalQuestion: true,
	initialMessage:
		"👋 I'm **{{alias}}**. Let's review this and sharpen your skills.",
	initialAiMessage: {
		"en-US": "👋 I'm **{{alias}}**. Let's review this and sharpen your skills.",
		"zh-CN":
			"👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**",
	},
};
